module.exports = __webpack_public_path__ + "img/brand_logo_dodge.efa318de.png";